import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { PageHeader } from '@/components/ui-kit/PageBits';
import { Trophy, Clock, Users, MessageCircle, Copy } from 'lucide-react';
import { toast } from 'sonner';

export default function RecapsList() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get('/classroom-recaps').then(r => setItems(r.data)); }, []);
  const copyShare = (t) => {
    const url = `${window.location.origin}/recap/${t}`;
    navigator.clipboard.writeText(url); toast.success('Enlace copiado');
  };
  return (
    <div className="p-8 max-w-5xl mx-auto">
      <PageHeader title="Sesiones guardadas" subtitle="Grabaciones de tus clases anteriores"/>
      {items.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-slate-300 p-12 text-center text-sm text-slate-500">
          Cada clase se guarda automáticamente al salir del salón. Sin sesiones aún.
        </div>
      ) : (
        <div className="space-y-3">
          {items.map(r => (
            <div key={r.id} data-testid={`recap-${r.id}`} className="rounded-2xl bg-white border border-slate-200 p-5">
              <div className="flex items-start justify-between mb-2">
                <div>
                  <div className="font-display font-bold text-lg">{r.name}</div>
                  <div className="text-xs text-slate-500 font-mono">
                    <Clock className="w-3 h-3 inline mr-1"/>
                    {new Date(r.started_at).toLocaleString()} → {new Date(r.ended_at).toLocaleTimeString()}
                  </div>
                </div>
                <button data-testid={`recap-share-${r.id}`} onClick={()=>copyShare(r.share_token)}
                  className="inline-flex items-center gap-1 text-xs font-semibold text-blue-600 hover:underline">
                  <Copy className="w-3 h-3"/> Compartir
                </button>
              </div>
              <div className="flex flex-wrap gap-4 text-sm text-slate-600 mb-3">
                <span><Users className="w-4 h-4 inline mr-1"/>{r.participants?.length || 0}</span>
                <span>♟️ {r.moves?.length || 0} jugadas</span>
                <span><MessageCircle className="w-4 h-4 inline mr-1"/>{r.chat?.length || 0} mensajes</span>
                <span><Trophy className="w-4 h-4 inline mr-1"/>{r.leaderboard?.length || 0} en ranking</span>
              </div>
              <Link to={`/recap/${r.share_token}`} className="text-sm text-blue-600 font-semibold">Ver recap →</Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
